import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const CTASection = ({ onOpenContactForm, imagePosition = 'right', heading, paragraph, buttonText, imageSrc }) => {
  return (
    <section className="py-24 bg-[#F4F4F5]" data-testid="cta-section">
      <div className="container mx-auto px-6 lg:px-16">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className={`space-y-6 ${imagePosition === 'right' ? 'order-1' : 'order-1 lg:order-2'}`}>
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-500">Take Action</p>
            <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#09090B]" style={{fontFamily:'Outfit,sans-serif'}} data-testid="cta-heading">{heading}</h2>
            <p className="text-sm leading-relaxed text-zinc-600">{paragraph}</p>
            <Button onClick={onOpenContactForm} className="btn-lift bg-[#002FA7] hover:bg-[#001D66] text-white px-6 py-5 font-semibold rounded-md" data-testid="cta-button">
              {buttonText} <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </div>
          <div className={`${imagePosition === 'right' ? 'order-2' : 'order-2 lg:order-1'}`}>
            <div className="rounded-lg overflow-hidden">
              <img src={imageSrc} alt={heading} className="w-full aspect-[4/3] object-cover" data-testid="cta-image" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
